import * as React from "react";
import { ApiContext } from "../../../App";

import { default as DataGrid } from "../../../components/LocalizedDataGrid";
import { GridToolbarContainer, GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";

import HvacEditPopUp from "./HvacEditPopUp";

import { useTranslation } from "react-i18next";
import HvacBulkAddPopUp from "./HvacBulkAddPopUp";

function CreateToolbar(props) {

    const { handleAddClick, handleBulkAddClick } = props;
    const { t } = useTranslation();


    return (
        <GridToolbarContainer>
            <Button
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAddClick}
            >
                {t("Add HVAC")}
            </Button>
            <Button
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleBulkAddClick}
            >
                {t("Bulk import HVACs (csv)")}
            </Button>
        </GridToolbarContainer>
    )
}


export default function HvacEditor(props) {

    const { facility } = props;

    const { t, i18n } = useTranslation();

    const { hvacApi, pointsApi, floorPlanApi, tariffApi } = React.useContext(ApiContext)

    const [hvacData, setHvacData] = React.useState([]);
    const [points, setPoints] = React.useState([]);
    const [tariffs, setTariffs] = React.useState([]);
    const [floorPlans, setFloorPlans] = React.useState([]);

    const [editPopUpOpen, setEditPopUpOpen] = React.useState(false);
    const [editPopUpData, setEditPopUpData] = React.useState({});
    const [bulkAddPopUpOpen, setBulkAddPopUpOpen] = React.useState(false);

    React.useEffect(() => {
        hvacApi.list(
            facility,
            (data) => {
                setHvacData(data);
            },
            () => {
                window.alert(t("Couldn't connect to server."));
            }
        );

        pointsApi.list(
            facility,
            (data) => {
                setPoints(data);
            },
            () => {
                window.alert(t("Couldn't connect to server."));
            }
        );

        tariffApi.list(
            facility,
            (data) => {
                setTariffs(data);
            },
            () => {
                window.alert(t("Couldn't connect to server."));
            }
        );

        floorPlanApi.list(
            facility,
            (data) => {
                setFloorPlans(data);
            },
            () => {
                window.alert(t("Couldn't connect to server."));
            }
        );

    }, [facility]);

    const handleEditClick = (url) => {
        setEditPopUpData(hvacData.find((item) => item.url === url))
        setEditPopUpOpen(true);
    }

    const handleDeleteClick = (url) => {
        const confirmed = window.confirm(t("Delete this HVAC unit?"))
        if (confirmed) {
            hvacApi.delete(url, () => {
                setHvacData(hvacData.filter((row) => row.url !== url))
            }, () => {
                alert(t("Could not delete HVAC unit."))
            })
        }
    }

    const handleAddClick = () => {

        setEditPopUpData({
            facility: facility
        });
        setEditPopUpOpen(true);
    }

    const handleBulkAddClick = () => {
        setBulkAddPopUpOpen(true);

    }

    const handleEditPopUpClosedWithoutSaving = () => {
        setEditPopUpOpen(false);
    };

    const handleEditPopUpClosedWithUpdate = (newData) => {

        if (hvacData.find((item) => item.url === newData.url))
            setHvacData(hvacData.map((row) => (row.url === newData.url ? newData : row)));
        else
            setHvacData((oldRows) => [...oldRows, newData]);

        setEditPopUpOpen(false);
    };

    const handleBulkAddPopUpClosedWithoutSaving = () => {
        setBulkAddPopUpOpen(false);
    };

    const handleBulkAddPopUpClosedWithImport = (newData) => {
        setHvacData((oldRows) => [...oldRows, ...newData]);
        setBulkAddPopUpOpen(false);
    };



    const columns = [
        { field: "location", headerName: t("Location"), flex: 1, minWidth: 200 },
        { field: "name", headerName: t("Name"), flex: 1, minWidth: 200 },
        { field: "automated", headerName: t("Automated"), type: "boolean", flex: 0.5, minWidth: 100 },
        {
            field: "actions",
            type: "actions",
            headerName: t("Actions"),
            flex: 0.5,
            minWidth: 150,
            cellClassName: "actions",
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label={t("Edit")}
                        className="textPrimary"
                        onClick={() => handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label={t("Delete")}
                        onClick={() => handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            }
        }
    ]


    return (
        <>
            <DataGrid
                rows={hvacData}
                columns={columns}
                getRowId={(row) => row.url}
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                    Toolbar: CreateToolbar,
                }}
                componentsProps={{
                    toolbar: {
                        handleAddClick,
                        handleBulkAddClick
                    }
                }}
            />
            <HvacEditPopUp
                open={editPopUpOpen}
                data={editPopUpData}
                onCloseWithoutSaving={handleEditPopUpClosedWithoutSaving}
                onCloseWithUpdate={handleEditPopUpClosedWithUpdate}
                floorPlans={floorPlans}
                points={points}
                tariffs={tariffs}
            />
            <HvacBulkAddPopUp
                open={bulkAddPopUpOpen}
                onCloseWithoutBulkImport={handleBulkAddPopUpClosedWithoutSaving}
                onCloseWithBulkImport={handleBulkAddPopUpClosedWithImport}
                floorPlans={floorPlans}
                points={points}
                tariffs={tariffs}
                facility={facility}
            />
        </>
    )


}